/**
 * formatXAxisTick
 * Function to format tick values for the x-axis
 */
export function formatXAxisTick(date: unknown) {
    if (!date) {
        return "";
    }

    return (date as Date).toLocaleString("en-us", {
        month: "numeric",
        day: "numeric",
        year: "2-digit",
        timeZone: "utc",
    });
}
